// Результат задания печати: опрашивает статус задания и, как только PDF
// отрисован, показывает кнопки «Открыть / Скачать PDF» (общий PdfActions).
//
// Общий компонент для любого диалога печати, который умеет вернуть job_id
// (QR станций/рулонов и др.).  Это и есть «системная» часть: достаточно
// отдать job_id — и пользователь сможет забрать PDF, не идя в историю печати.

import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { printApi } from "@/lib/api";
import { PdfActions } from "@/components/PdfActions";

export function PrintJobResult({
  jobId,
  initialStatus = "queued",
  autoDownload = false,
}: {
  jobId: string;
  initialStatus?: string;
  autoDownload?: boolean;
}) {
  const [status, setStatus] = useState(initialStatus);
  const norm = status.toUpperCase();
  const polling = norm === "QUEUED" || norm === "RUNNING";

  const q = useQuery({
    queryKey: ["print", "job", jobId],
    queryFn: () => printApi.getJob(jobId),
    enabled: polling,
    refetchInterval: 1500,
  });

  useEffect(() => {
    if (q.data?.status) setStatus(String(q.data.status));
  }, [q.data]);

  const isDone = norm === "DONE";
  const isFailed = norm === "FAILED" || norm === "CANCELLED";

  return (
    <div className="rounded-md border border-border bg-surface-alt/40 p-3 space-y-2">
      {!isDone && !isFailed && (
        <p className="text-sm text-text-muted">Готовится PDF…</p>
      )}
      {isFailed && (
        <p className="text-sm text-state-danger">Не удалось подготовить PDF.</p>
      )}
      {isDone && (
        <>
          <p className="text-sm text-text-muted">PDF готов — можно открыть или скачать.</p>
          <PdfActions jobId={jobId} autoDownload={autoDownload} />
        </>
      )}
    </div>
  );
}
